import { translate } from "shared/languages";
import PATHS from "shared/constants/paths";
import PackagePurchasesContent from "./PackagePurchasesContent";

const MembershipPurchasesPage = () => (
  <PackagePurchasesContent
    type="membership"
    title={translate("analyticsPage.membership.report_purchases")}
    backTo={PATHS.ANALYTICS}
  />
);

export default MembershipPurchasesPage;
